module.exports = __webpack_public_path__ + "img/pic_162914_2.8467ad65.jpg";